"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _consts = require("../../utils/layout/consts");

var getDirectionSpacingTemplate = function getDirectionSpacingTemplate(direction) {
  switch (direction) {
    case _consts.DIRECTIONS.COLUMN:
      return "0 0 __spacing__ 0";

    case _consts.DIRECTIONS.ROW:
      return "0 __spacing__ 0 0";

    case _consts.DIRECTIONS.COLUMNREVERSE:
      return "__spacing__ 0 0 0";

    case _consts.DIRECTIONS.ROWREVERSE:
      return "0 0 0 __spacing__";

    default:
      return "0 0 __spacing__ 0";
  }
};

var _default = getDirectionSpacingTemplate;
exports.default = _default;